import api from './api';

export interface Country {
  id: number;
  name: string;
  flag: string;
}

export interface Wilaya {
  id: number;
  country_id: number;
  name: string;
}

class CountriesService {
  async getCountries(): Promise<Country[]> {
    const response = await api.get('/countries');
    return response.data;
  }

  async getCountry(id: number): Promise<Country> {
    const response = await api.get(`/countries/${id}`);
    return response.data;
  }

  async getWilayas(countryId?: number): Promise<Wilaya[]> {
    const url = countryId ? `/wilayas/by-country/${countryId}` : '/wilayas';
    const response = await api.get(url);
    return response.data;
  }

  async getWilaya(id: number): Promise<Wilaya> {
    const response = await api.get(`/wilayas/${id}`);
    return response.data;
  }
}

export default new CountriesService();
